import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'nk-card',
  imports: [],
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() public andClass = '';
  @Input() public id = '';
  @Input() public dense = false;
  @Input() public small = false;
  @Input() public type = '';
  @Input() public cardList = false;
  @Input() public cardMainList = false; // this will also set cardList class
}
